import { render } from "./Descontos.vue?vue&type=template&id=72e3c9b2&scoped=true"
import script from "./Descontos.vue?vue&type=script&lang=js"
export * from "./Descontos.vue?vue&type=script&lang=js"

import "./Descontos.vue?vue&type=style&index=0&id=72e3c9b2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e3c9b2"]])

export default __exports__